const PC_DOMAIN = 'http://www.luigallery.com'; //线上环境PC端域名
//const PC_DOMAIN = 'http://devtest04.eetop.com'; //测试环境PC端域名

const DOMAIN_PATH = 'http://www.luigallery.com/mobileapi/';//线上环境域名npm
//const DOMAIN_PATH = 'http://kftest2.eetop.com/mobileapi/',//测试环境域名
//const DOMAIN_PATH = 'http://devtest04.eetop.com/mobileapi/';

export const API_LIST = {
    baseInfo: DOMAIN_PATH + 'index.php?t=gallery&act=gallery&f=menu',
    painterList: DOMAIN_PATH + 'index.php?t=painters&act=painters&f=list',
    painterDetail: DOMAIN_PATH + 'index.php?t=painters&act=painters&f=detail',
    workList: DOMAIN_PATH + 'index.php?t=works&act=works&f=list',
    workDetail: DOMAIN_PATH + 'index.php?t=works&act=works&f=detail',
    aboutDetail: DOMAIN_PATH + 'index.php?t=gallery&act=gallery&f=detail',
    pcLinkUrl: PC_DOMAIN
};



// WEBPACK FOOTER //
// ./src/utils/config.js